import { fetchAuthSession } from 'aws-amplify/auth';
import { withCredentialProvider } from '@aws/amazon-location-utilities-auth-helper';
import type { MapAuthHelper, SDKAuthHelper } from '@aws/amazon-location-utilities-auth-helper';
import outputs from '../../amplify_outputs.json';

type GeoOutputs = {
  aws_region: string;
  maps: { items: Record<string, unknown>; default: string };
  search_indices: { items: string[]; default: string };
};

const geo = (outputs as { geo?: GeoOutputs }).geo;

export const GEO_VERFUEGBAR = Boolean(geo);
export const GEO_REGION = geo?.aws_region ?? '';
export const KARTEN_NAME = geo?.maps.default ?? '';
export const PLACE_INDEX = geo?.search_indices.default ?? '';

let helperPromise: Promise<MapAuthHelper & SDKAuthHelper> | null = null;

/**
 * Ein gemeinsamer Auth-Helper für Amazon Location Service, der die
 * Zugangsdaten der bereits angemeldeten Amplify-Sitzung wiederverwendet
 * (nicht die Unauthenticated-Rolle — die hat sowieso keine Location-Rechte,
 * siehe backend.ts / technical-design.md Abschnitt 7).
 */
export function holeLocationAuthHelper() {
  if (!GEO_VERFUEGBAR) {
    return Promise.reject(new Error('Kartendienst ist noch nicht konfiguriert (kein Deploy?).'));
  }
  if (!helperPromise) {
    helperPromise = withCredentialProvider(async () => {
      const session = await fetchAuthSession();
      if (!session.credentials) throw new Error('Keine AWS-Anmeldedaten in der aktuellen Sitzung.');
      return session.credentials;
    }, GEO_REGION);
  }
  return helperPromise;
}

export function kartenStilUrl(): string {
  return `https://maps.geo.${GEO_REGION}.amazonaws.com/maps/v0/maps/${KARTEN_NAME}/style-descriptor`;
}
